module.exports = __webpack_public_path__ + "static/img/li_1.75a2329.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_1.jpeg
// module id = HjG1
// module chunks = 6